<template>
	<div class="itemStore">
		<header class="d-flex j-sb a-center" style="height: 1.69rem;">
			<div class="d-flex j-center a-center" v-for="(item,index) in tab" :key="index" @click="changeTab(index)">
				<a @mouseover="cur_hover=index" @mouseleave="cur_hover=null" class="tab d-flex j-center a-center" :href="item.path"
					:style="cur_hover == index||cur_tab == index?'color:#FFFFFF;background: #1E69FF;':'color: #1E69FF;'">
					<img :src="cur_hover==index||cur_tab == index?item.active_icon:item.icon" style="width: 1.13rem;height: 1.13rem;">
					<span style="margin-left: 0.69rem;">{{item.name}}</span>
				</a>
			</div>
			<div class="d-flex j-center a-center" @click="$router.push('publish_item')">
				<a @mouseover="addpulishState = true" @mouseleave="addpulishState = false" class="tab d-flex j-center a-center" 
					:style="addpulishState == true?'color:#FFFFFF;background: #1E69FF;':'color: #1E69FF;'">
					<img :src="addpulishState == true?addpulish.active_icon:addpulish.icon" style="width: 1.13rem;height: 1.13rem;">
					<span style="margin-left: 0.69rem;">添加产品</span>
				</a>
			</div>
			<div class="d-flex j-center a-center" @click="$router.push('publish_serve')">
				<a @mouseover="addflState = true" @mouseleave="addflState = false" class="tab d-flex j-center a-center" 
					:style="addflState == true?'color:#FFFFFF;background: #1E69FF;':'color: #1E69FF;'">
					<img :src="addflState == true?addfl.active_icon:addfl.icon" style="width: 1.13rem;height: 1.13rem;">
					<span style="margin-left: 0.69rem;">添加分类</span>
				</a>
			</div>
			<div class="search">
				<input type="text" v-model="keyword" @input="searchGodosss" @change="searchGodos" placeholder="输入商品编号/商品名称">
				<div class="icon d-flex j-center a-center" style="cursor: pointer;" @click="searchGodos">
					<i class="el-icon-search"></i>
				</div>
			</div>
		</header>
		<component :is="tab[cur_tab].component" :keyword="keyword" ref="child"></component>
	</div>
</template>

<script>
	import onSaleTable from './table/on_sale_table.vue'
	import onSaleTable1 from './table/on_sale_table1.vue'
	import stockTable from './table/stock_table.vue'
	import recycleBinTable from './table/recycle_bin_table.vue'
	import apolegamyTable from './table/apolegamy_table.vue'
	export default {
		components: {
			onSaleTable,
			stockTable,
			recycleBinTable,
			apolegamyTable,
			onSaleTable1
		},
		data() {
			return {
				cur_tab: 0 | localStorage.getItem('item_store_tab'),
				tab: [{
						icon: require('@/assets/itemStore/csmr@2x.png'),
						active_icon: require('@/assets/itemStore/csxz@2x.png'),
						name: '展示中的产品',
						component: 'onSaleTable'
					}, {
						icon: require('@/assets/itemStore/ckmr@2x.png'),
						active_icon: require('@/assets/itemStore/ckxz@2x.png'),
						name: '已隐藏的产品',
						component: 'stockTable'
					},{
						icon: require('@/assets/itemStore/ckmr@2x.png'),
						active_icon: require('@/assets/itemStore/ckxz@2x.png'),
						name: '产品/服务分类',
						component: 'onSaleTable1'
					},
				],
				addpulish :{
					icon: require('@/assets/itemStore/tjmr@2x.png'),
					active_icon: require('@/assets/itemStore/tjxz@2x.png'),
					name: '添加产品',
					path: 'publish_item',
				},
				addfl :{
					icon: require('@/assets/itemStore/tjmr@2x.png'),
					active_icon: require('@/assets/itemStore/tjxz@2x.png'),
					name: '添加分类',
					path: 'publish_serve',
				},
				addpulishState : false,
				addflState : false,
				cur_hover: null,
				keyword: '',

			}
		},
		methods: {
			changeTab(index){
				this.cur_tab = index
				this.keyword = ''
				localStorage.setItem('item_store_tab',index)
			},
			searchGodos(){
				this.keyword = ''
				localStorage.setItem('item_store_tab',0)
				this.$refs.child.$emit("childmethods")
			},
			searchGodosss(){
				// 节流,避免输入过快多次请求
				if(this.keyword == ''){
					this.searchTimer && clearTimeout(this.searchTimer)
					this.searchTimer = setTimeout(()=>{					
						this.keyword = ''
						this.$refs.child.$emit("childmethods")
					},100)
				}else{
					return
				}
			}
		}
	}
</script>
<style lang="scss">
	.el-table thead {
		color: #000000 !important;
		font-size: 0.88rem;
	}
</style>
<style lang="scss" scoped>
	// input[type="checkbox"] {
	// 	width: 1.13rem;
	// 	height: 1.13rem;
	// 	-webkit-appearance: none;
	// 	border: 1px solid #c9c9c9;
	// 	border-radius: 10px;
	// 	outline: none;
	// 	cursor: pointer;
	// }

	// input[type=checkbox]:checked {
	// 	background: url("@/assets/itemStore/xuanzhong@2x.png")no-repeat;
	// 	background-size: 100% 100%;
	// }

	.itemStore {
		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;

		.tab {
			background: #FFFFFF;
			border: 2px solid #1E69FF;
			border-radius: 6px;
			font-size: 0.75rem;
			text-align: center;
			height: 1.75rem;
			box-sizing: border-box;
			cursor: pointer;
			width: 9.38rem;
			color: inherit;
			text-decoration: none;
		}

		.search {
			width: 16.9rem;
			height: 1.69rem;
			position: relative;

			input {
				font-size: 0.75rem;
				outline: none;
				border: 2px solid #1E69FF;
				border-radius: 4px;
				padding: 0 1.44rem;
				height: 100%;
				width: 100%;
				box-sizing: border-box;

				&::placeholder {
					font-size: .75rem;
				}
			}

			.icon {
				background: #1E69FF;
				height: 100%;
				padding: 0 0.38rem;
				position: absolute;
				right: 0;
				top: 50%;
				transform: translateY(-50%);
				border-radius: 0 4px 4px 0;

				i {
					color: #FFFFFF;
				}
			}


			&::-webkit-input-placeholder {
				color: #BBBBBB;
				font-size: 0.77rem;	
			}
		}
	}
</style>
